module.exports = __webpack_public_path__ + "static/media/203_SHOT_081.f0b554d6.webp";